var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppSidebar'),_c('AppHeader'),_c('v-main',[_c('v-container',{staticClass:"page-wrapper",attrs:{"fluid":""}},[_c('div',{staticClass:"maxWidth"},[_c('v-scroll-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)])],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }